import React, { useState, useEffect, useRef } from "react";
import printStatus from "./PrintStatus";
import pako from "pako";

/**
 * React component to show description of state.
 * The only prop is `state` which can be
 * - a state object
 * - JSON-encoded state
 * - compressed string
 */

function StateDescriptionPanel({ state, mode }) {
  try {
    if (typeof state !== "object") throw new Error('State is not an object');
    return <div className="state-description-panel">{printStatus(state, mode)}</div>;
  } catch (error) {
    return <div>Не удалось прочитать состояние!</div>;
  }
}

export default React.memo(StateDescriptionPanel);
